<template>
  <div class="otn-block">
    <h3 class="otn-block__title">{{ $t('view.flow.block.otn.title') }}</h3>
    <div class="otn-block__wrapper">
      <in
        :label="$t('view.flow.block.otn.name')"
        v-model="val.name"
        class="otn-block__input"
        @input="onInput"
        maxlength="32"
      ></in>
      <div class="otn-block__label">{{ $t('view.flow.block.otn.content') }}</div>
      <textarea-autosize
        v-model="val.content[$store.state.flowEditorLocale]"
        class="otn-block__textarea"
        @input="onInput"
        maxlength="65"
      ></textarea-autosize>
      <sel
        :label="$t('view.flow.block.otn.confirmationBlock')"
        v-model="val.confirmationBlock"
        class="otn-block__input"
        @input="onInput"
      >
        <optgroup v-for="group in this.$store.state.flowGroups" :key="group.id" :label="group.name">
          <option v-for="block in group.blocks" :key="block.id" :value="block.uuid">{{ block.name }}</option>
        </optgroup>
      </sel>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.otn-block {
  @include flowElementShadow();
  width: 30%;
  min-width: 380px;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__input {
    margin-top: 10px;
    width: 75%;
    margin-right: 25px;
  }

  &__textarea {
    margin-right: 25px;
    border: 1px solid $borderGrey;
    border-radius: 4px;
    font-size: 1em;
    padding: 5px 6px;
    width: calc(75% - calc(calc(2 * 5px)) - 2px);
    outline: none !important;
    font-family: "Lato";
  }

  &__label {
    @include labelStyle;
    margin-top: 10px;
  }
}
</style>
